// removed by extract-text-webpack-plugin
module.exports = {"pshs-wrap":"pshs-wrap___20lam","take-action-share":"take-action-share___170xM center___2iqBf","take-action-label":"take-action-label___1tH_X","take-action-icons":"take-action-icons___1j0f5 center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardHeaderShare/PlanScorecardHeaderShare.css
// module id = 903
// module chunks = 0